import React from 'react';
import { Card } from '../ui/card';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

const MaintenancePage = ({ message }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-yellow-100 dark:bg-yellow-900/20 p-4 rounded-full">
            <WrenchScrewdriverIcon className="h-12 w-12 text-yellow-600 dark:text-yellow-500" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-foreground mb-4">
          System Maintenance
        </h1>
        
        <p className="text-muted-foreground mb-6">
          {message || 'We are currently performing scheduled maintenance. Please check back shortly.'}
        </p>
        
        <div className="text-sm text-muted-foreground">
          We apologize for any inconvenience.
        </div>
      </Card>
    </div>
  );
};

export default MaintenancePage;


